import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/** Shared chrome for Privacy / Terms / Refund / Juror Code of Conduct pages.
 *  Editorial column with ample left-aligned breathing room. Children render as
 *  plain MDX-style React (<h2>, <p>, <ul>) and inherit the editorial styles
 *  defined below. */
export const LegalPage = ({ kicker, title, lastUpdated, children }) => {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, []);
  return (
    <article data-testid={`legal-page-${title.replace(/\s+/g, '-').toLowerCase()}`} className="content-container py-16 md:py-24 max-w-3xl">
      <Link
        to="/"
        data-testid="legal-back-home"
        className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.32em] uppercase text-[var(--ink-muted)] hover:text-[var(--gold)] transition-colors mb-10"
      >
        <ChevronLeft size={14} /> Back home
      </Link>

      <div className="text-[11px] tracking-[0.42em] uppercase text-[#9F6A2C] mb-3">{kicker}</div>
      <h1 className="font-serif text-3xl md:text-5xl tracking-[-0.01em] leading-[1.15] text-[var(--ink)]">
        {title}
      </h1>
      {lastUpdated && (
        <p className="mt-4 text-[12px] tracking-[0.18em] uppercase text-[var(--ink-muted)]">
          Last updated · {lastUpdated}
        </p>
      )}

      <div className="legal-prose mt-12 space-y-8">
        {children}
      </div>

      <div className="mt-16 pt-8 border-t border-[#B8884A]/25 text-[12.5px] text-[var(--ink-muted)] leading-[1.8]">
        Questions about this document? Write to{' '}
        <a href="mailto:awards@marketingmind.co" className="text-[#9F6A2C] underline decoration-[#B8884A]/40 underline-offset-4 hover:decoration-[#9F6A2C]">awards@marketingmind.co</a>{' '}
        or call our awards desk in Noida. We respond within two business days.
      </div>
    </article>
  );
};

export default LegalPage;
